import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgHttpLoaderModule } from 'ng-http-loader';


import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { AgmCoreModule } from '@agm/core';
import { EmbedVideo } from 'ngx-embed-video';
import { InputFileConfig, InputFileModule } from 'ngx-input-file';
const config: InputFileConfig = {
    fileAccept: '*'
};

import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

import { AppRouting } from './app.routing';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { AppSettings } from './app.settings';
import { AppInterceptor } from './theme/utils/app-interceptor';


import { PagesComponent } from './pages/pages.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { Toolbar1Component } from './theme/components/toolbar1/toolbar1.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { CurrencyComponent } from './theme/components/currency/currency.component';


import { LangComponent } from './theme/components/lang/lang.component';
import { SocialIconsComponent } from './theme/components/social-icons/social-icons.component';
import { ContactsComponent } from './theme/components/contacts/contacts.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import { LockScreenComponent } from './pages/lock-screen/lock-screen.component';

import { AlertService } from '../services/alert.service';
import { UserSessionService } from '../services/usersession.service';
import { DataService } from '../services/data.service';
import { HttpInterceptorService } from '../services/interceptor.service';
import { AuthGuard } from './shared/auth/auth-guard.service';
import { AuthenticationService } from '../services/authentication.service';
import { ToastrModule } from 'ngx-toastr';
import { MenuService } from '../services/menu.service';
import { PageContentService } from '../services/pagecontent.service';
import { BroadcastMessageService } from '../services/broadcastMessageService';
import { FacebookModule } from 'ngx-facebook';
import { DigiVolunteerService } from 'src/services/digivolunteer.service';
// import { NgImageSliderModule } from 'ng-image-slider';
import { Ng2OdometerModule } from 'ng2-odometer';
import { LightboxModule } from 'ngx-lightbox';






@NgModule({
    declarations: [
        AppComponent,
        PagesComponent,
        NotFoundComponent,
        UserMenuComponent,
        CurrencyComponent,
        LangComponent,
        SocialIconsComponent,
        ContactsComponent,
        Toolbar1Component,
        HorizontalMenuComponent,
        FooterComponent,
        LockScreenComponent,
        
        

    ],
    imports: [
        LightboxModule,
        // NgImageSliderModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        NgHttpLoaderModule.forRoot(),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDLf9Ywk47zipEtorDewwMmB3JtuXdzYL4',
            libraries: ["places"]
        }),
        EmbedVideo.forRoot(),
        NgProgressModule,
        NgProgressHttpModule,
        InputFileModule.forRoot(config),
        AppRouting,
        SharedModule,
        FacebookModule.forRoot(),
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
        }),
        Ng2OdometerModule.forRoot(),
    ],
    providers: [
        AppSettings,
        AuthGuard,
        AuthenticationService,
        UserSessionService,
        AlertService,
        DataService,
        MenuService,
        PageContentService,
        BroadcastMessageService,
        DigiVolunteerService,
        HttpInterceptorService,
        
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true
        },
        { provide: OverlayContainer, useClass: CustomOverlayContainer },
        { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true }
    ],
    bootstrap: [AppComponent]
    //entryComponents:
    //    [
    //        ReadmoredialogComponent,
    //        ChathelpdialogComponent,
    //        DialogboxComponent
    //    ]
})
export class AppModule { }
